import axios from "axios";
import { inject, provide, reactive, toRefs } from "@vue/composition-api";
import { actions as appActions } from "../modules/app";

export const state = reactive({});

export const actions = {
    saveRole(account_id, data) {
        return new Promise((resolve, reject) => {
            let url = "a/{0}/roles/{1}/".format(account_id, data.id);
            axios
                .post(url, data)
                .then(resp => {
                    appActions.syncToClassifiersCache("roles", resp.data, account_id);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
    deleteRole(account_id, role_id, params = null) {
        return new Promise((resolve, reject) => {
            let url = "a/{0}/roles/{1}/".format(account_id, role_id);
            axios
                .delete(url, { params: params })
                .then(resp => {
                    if (params == null || !params.validate_only)
                        appActions.removeFromClassifiersCache("roles", role_id, account_id);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
};

export const key = Symbol("RoleModule");

export const provideRole = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    });
};

export default () => inject(key);
